import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Parent  {
    _originalTypeClassName = "ekylikeio.BO.Parent";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Parent.translate = translateService;
}
this.parentToStudent = [];
this.Id = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FullName:any;
parentToStudent:any;
UserAcount:any;
static setparentToStudent = ($this, items) => {
                if (items == null) items = [];
                if ($this.parentToStudent == null) $this.parentToStudent = [];

                const copyItems = Common.cloneObject(items);

                while ($this.parentToStudent.length > 0) {
                    Domain.Parent.removeparentToStudent($this, $this.parentToStudent[0]);
                }

                Domain.Parent.addManyparentToStudent($this, copyItems);
            }
static addManyparentToStudent = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Parent.addparentToStudent($this, items[i]);
                }
            }
static addparentToStudent = ($this, item) => {
                if ($this.parentToStudent == null) $this.parentToStudent = [];
                if (item == null || $this.parentToStudent.indexOf(item) > -1) return;
                $this.parentToStudent.push(item);
if (item.Parent != $this) {
Domain.Student.setParent(item, $this);
}
}
static addRangeparentToStudent = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Parent.addparentToStudent($this, item));
            }
static removeparentToStudent = ($this, item) => {
                if ($this == null || $this.parentToStudent == null || $this.parentToStudent.indexOf(item) === -1) return;
                var _index = $this.parentToStudent.indexOf(item);
                $this.parentToStudent.splice(_index, 1);
item.Parent = null;
}
static clearparentToStudent = ($this) => { $this.parentToStudent = null; }
static setUserAcount = ($this, value) => {
var oldValue = $this.UserAcount;
$this.UserAcount = value;
if (value != null) {
if (oldValue != null && oldValue.Parent != null) { oldValue.Parent = null; }
if ($this.UserAcount.Parent !== $this) {
Domain.UserAcount.setParent(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}